/**
 * url, options {
 *   async:  true | false
 *   method: GET | POST
 *   contentType:
 *   success: callback function e.g. function(result) { do something with result }
 *   data: for POST, doesn't do anything when GET
 * }
  example:
    rwg.ajax('create_user_sql.php', {
      method: 'POST',
      success: function(response) {
        console.log(response);
      },
      data: JSON.stringify({
        username: username,
        password: password,
        company, company
      })
    });
 */
export default function(url, options) {
  // make the url parameter option and allow passing just an "options" object that includes the url
  if (typeof url !== 'string') {
    options = url;
    url = options.url;
  }
  if (options === undefined) {
    options = {};
  }
  var xhr = new XMLHttpRequest();
  var async = typeof options.async === 'boolean' ? options.async : true;
  xhr.open(options.method || 'GET', url, async);
  if (options.contentType) {
    xhr.setRequestHeader('Content-Type', options.contentType);
  }

  xhr.onload = function() {
    if (xhr.status >= 200 && xhr.status < 400) {
      if (typeof options.success === 'function') {
        options.success(xhr.responseText, xhr.status, xhr); // also return the xhr object so you can do e.g. xhr.getResponseHeader('content-type');
      }
    } else {
      console.error('Server reported error:', xhr.status);
    }
  };
  xhr.onerror = function() {
    console.error('XMLHttpRequest error');
  };
  if (options.data !== 'undefined') {
    xhr.send(options.data);
  } else {
    xhr.send();
  }
}
